import { acquireAccessToken } from "./AuthProvider";
import { API_URL } from "./Constants";
import { ICollection } from "./model/ICollection";

type Method = 'GET' | 'POST' | 'DELETE' | 'PUT';

export const request = async (uri: string, method: Method, body?: BodyInit, headers?: Record<string, string>) => {
  const rsp = await fetch(uri,
    {
      method,
      body,
      headers: {
        'Bearer': await acquireAccessToken(),
        'Content-Type': 'application/json',
        ...headers
      }
    });

  if (!rsp.ok) {
    let message = rsp.statusText;
    try {
      const errorObject = await rsp.text();
      message = errorObject;
    } catch (e) {
      throw message;
    }
    throw message;
  }

  return rsp;
}

export const getAll = async <T>(resource: string, queryParam?: string): Promise<T[]> => {
  let url = `${API_URL}/${resource}`;
  if (queryParam) {
    url += `?${queryParam}`;
  }
  const response = await request(url, 'GET');
  const json: ICollection<T> = await response.json();
  return json.value;
};

export const get = async <T>(resource: string, id: string): Promise<T> => (await request(`${API_URL}/${resource}/${id}`, 'GET')).json();

export const create = <T>(resource: string, body: T) => request(`${API_URL}/${resource}`, 'POST', JSON.stringify(body));

export const remove = (resource: string, id: string) => request(`${API_URL}/${resource}/${id}`, 'DELETE');

export const update = <T>(resource: string, body: T) => request(`${API_URL}/${resource}`, 'PUT', JSON.stringify(body));

